import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48b26af8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "resetPassContainer" }
const _hoisted_2 = { class: "layout gutter--md" }
const _hoisted_3 = { class: "row justify--center" }
const _hoisted_4 = { class: "flex md6 xs12" }
const _hoisted_5 = { class: "row justify--center" }
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = { class: "row justify--center" }
const _hoisted_8 = { class: "flex" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Opdater Adgangskoden")
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row justify--center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex" }, [
    /*#__PURE__*/_createElementVNode("b", null, "* Adgangskoden skal være på minimum 8 tegn, indeholde tal, specialtegn, store og små bogstaver")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_va_input = _resolveComponent("va-input")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_form = _resolveComponent("va-form")!
  const _component_va_card_content = _resolveComponent("va-card-content")!
  const _component_va_card = _resolveComponent("va-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_va_card, null, {
      default: _withCtx(() => [
        _createVNode(_component_va_card_content, null, {
          default: _withCtx(() => [
            _createVNode(_component_va_form, {
              ref: "resetPassForm",
              onValidation: _cache[3] || (_cache[3] = ($event: any) => (_ctx.validation = $event))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_va_input, {
                        type: "password",
                        modelValue: _ctx.newPassword,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newPassword) = $event)),
                        label: "Ny adgangskode *",
                        rules: [(v) => _ctx.testPassword(v) || 'Adganskoden er ikke stærk nok']
                      }, null, 8, ["modelValue", "rules"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_va_input, {
                        type: "password",
                        modelValue: _ctx.repeatPassword,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.repeatPassword) = $event)),
                        label: "Gentag adgangskode",
                        rules: [(v) => v === _ctx.newPassword || 'Adgangskoden er ikke ens']
                      }, null, 8, ["modelValue", "rules"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_va_button, {
                        class: "mt-4",
                        color: "success",
                        gradient: "",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$refs.resetPassForm.validate(), (_ctx.validation ? _ctx.updatePassword() : _ctx.$Message.danger({ text: 'Fejl: Kan ikke opdater adgangskoden' }))))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_9
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _hoisted_10
                ])
              ]),
              _: 1
            }, 512)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}